module.exports = __webpack_public_path__ + "static/media/credit_card_logos_horizontal_color_orig.e5c654b4.png";